var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: {
        name: _vm.transition,
        mode: "in-out",
        appear: "",
        "appear-active-class": _vm.enterClass,
        "enter-active-class": _vm.enterClass,
        "leave-active-class": _vm.leaveClass,
      },
      on: { beforeEnter: _vm.beforeEnter, afterLeave: _vm.afterLeave },
    },
    [
      _vm.show
        ? _c("div", { class: _vm.classes }, [
            _c("div", {
              staticClass: "modal-background",
              on: { click: _vm.deactive },
            }),
            _c("div", { staticClass: "modal-content" }, [_vm._t("default")], 2),
            _vm.closable
              ? _c("button", {
                  staticClass: "modal-close",
                  on: { click: _vm.deactive },
                })
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }